'use strict';

class LabelList {
  constructor($filter, labelService) {
    this.$filter = $filter;
    this.labelService = labelService;
  }

  $onInit() {
    this.labels = [];
    this.name = null;

    this.load();
  }

  load() {
    this.labelService.list()
      .then((resp) => {
        this.labels = resp.data;
        this.name = null;
      });
  }

  create() {
    this.labelService.create(this.name)
      .then(() => this.load());
  }

  remove(number) {
    if (number) {
      swal({
        title: 'Bekreft fjerning',
        showCancelButton: true,
        confirmButtonColor: '#970b0e',
        confirmButtonText: 'Ja',
        cancelButtonText: 'Nei',
        closeOnConfirm: false,
        showLoaderOnConfirm: true
      }, (answer) => {
        if (answer) {
          this.labelService.remove(number)
            .then(() => {
              swal.close();
              this.load();
            });
        }
      });
    }
  }
}

LabelList.$inject = ['$filter', 'labelService'];

const labelList = {
  controller: LabelList,
  template: `
    <h2>Grupper</h2>

    <form ng-submit="$ctrl.create()" name="labelForm" novalidate>
      <fieldset>
        <h3 class="subheader">Legg til gruppe</h3>
        <input id="name" type="text" ng-model="$ctrl.name" placeholder="Navn" name="name" required autofocus>
        <span class="error" ng-show="labelForm.name.$error.require && labelForm.name.$dirty">Påkrevd</span>
        <button type="submit" ng-disabled="labelForm.$invalid" ng-class="{ disabled: labelForm.$invalid }" class="button">Lagre</button>
      </fieldset>
    </form>

    <div ng-if="$ctrl.labels.length">
      <h3 class="subheader" ng-pluralize count="$ctrl.labels.length" when="{'0': 'Ingen grupper', '1': '1 gruppe', 'other': '{{ $ctrl.labels.length }} grupper'}"></h3>
      <table>
        <thead>
          <tr>
            <th>Navn</th>
            <th>Kunder</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr ng-repeat="label in $ctrl.labels | orderBy:'name' track by label.number">
            <td>
              <a href="#/grupper/{{ label.number }}">{{ label.name }}</a>
            </td>
            <td>{{ label.membersTotal }}</td>
            <td class="right-align">
              <a href role="button" class="button small alert" ng-click="$ctrl.remove(label.number)"><i class="fa fa-trash"></i> Slett</a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  `
};

angular
  .module('SendRegning')
  .component('labelList', labelList)
  .config(($routeProvider) => {
    $routeProvider
      .when('/grupper', {
        title: 'Grupper',
        template: '<label-list />',
        secure: true
      });
  });
